import { AttendeesList } from '@eventr/common'
import { Box, Stack } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AccordionTransition } from '../../common/AccordionTransition'
import { FilesFieldCard } from '../../feat/editItinerary/components/filesFieldCard'
import { TextFieldCard } from '../../feat/editItinerary/components/textFieldCard'
import { Expand } from '../../home/components/expand'
import i18n from '../../i18n/i18next'
import { EditButton } from '../componentCards/subComponents/editButton'
import { UsersList } from '../componentCards/subComponents/usersLists'

interface IActivitiesBookingBodyProps {
    id?: string
    data: AttendeesList
}

export const ActivitiesBookingBody = ({
    id,
    data,
}: IActivitiesBookingBodyProps) => {
    const nav = useNavigate()
    const [chevroClickOpen, setChevroClickOpen] = useState<boolean>(false)

    const userList = () => {
        const hideUserList = data?.users?.length === 0

        return (
            <>
                <Stack justifyContent={'space-between'} direction={'row'}>
                    {hideUserList ? (
                        <div />
                    ) : (
                        <Box
                            height={'24px'}
                            onClick={() => {
                                setChevroClickOpen(!chevroClickOpen)
                            }}
                        >
                            <Expand expanded={chevroClickOpen} />
                        </Box>
                    )}

                    <EditButton
                        path=""
                        onClick={() => {
                            nav(`./${data._id}`, { relative: 'path' })
                        }}
                    />
                </Stack>
                {!hideUserList && (
                    <AccordionTransition open={chevroClickOpen}>
                        <UsersList userList={data.users || []} showChat={false} />
                    </AccordionTransition>
                )}
            </>
        )
    }

    return (
        <Stack spacing={'16px'}>
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.316')}
                text={data.notes}
            />
            <FilesFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.documents')}
                files={data.documents as any}
            />
            {userList()}
        </Stack>
    )
}
